import { createReducer, on } from '@ngrx/store';
import * as ComplianceFormActions from './compliance-form.actions';
import {
  complianceFormInitialState,
  IComplianceFormState,
} from './compliance-form.state';
import { SettingsSubFeatures } from 'src/app/features/settings/models/sub-features';
import { Features } from 'src/app/features/features';

export const ComplianceFormReducer = createReducer(
  complianceFormInitialState,
  on(
    ComplianceFormActions.GetComplianceForm,
    (state: IComplianceFormState): IComplianceFormState => ({
      ...state,
      isLoaded: false,
    }),
  ),
  on(
    ComplianceFormActions.GetComplianceFormSuccess,
    (
      state: IComplianceFormState,
      { complianceForm },
    ): IComplianceFormState => ({
      ...state,
      isLoaded: true,
      complianceForm,
    }),
  ),
  on(
    ComplianceFormActions.GetComplianceFormError,
    (state: IComplianceFormState): IComplianceFormState => ({
      ...state,
      isLoaded: true,
    }),
  ),
  on(
    ComplianceFormActions.CheckComplianceFormSuccess,
    (state: IComplianceFormState): IComplianceFormState => ({
      ...state,
      isChecked: true,
    }),
  ),
  on(
    ComplianceFormActions.NavigateToComplianceForm,
    (state: IComplianceFormState, { returnToUrl }): IComplianceFormState => ({
      ...state,
      isEditing: true,
      returnToUrl: returnToUrl
        ? returnToUrl
        : `/${Features.SETTINGS}/${SettingsSubFeatures.CARRIER_APPOINTMENTS}`,
    }),
  ),
  on(
    ComplianceFormActions.ComplianceFormComplete,
    (state: IComplianceFormState): IComplianceFormState => ({
      ...state,
      isEditing: false,
    }),
  ),
);
